export default __webpack_public_path__ + "static/media/bressi.7fbf89f7.mp4";